import React, { memo } from 'react';
import { useModalState } from 'hooks';
import { CbmModal as Modal, Text } from '@groupelacentrale/contact-storybook';
import AdressDesktop from 'assets/ContactExample/image-adresse-desktop.png';
import AdressMobile from 'assets/ContactExample/image-adresse-mobile.png';
import EmailDesktop from 'assets/ContactExample/image-email-desktop.png';
import EmailMobile from 'assets/ContactExample/image-email-mobile.png';
import PhoneDesktop from 'assets/ContactExample/image-tel-desktop.png';
import PhoneMobile from 'assets/ContactExample/image-tel-mobile.png';
import NameDesktop from 'assets/ContactExample/image-nom-desktop.png';
import NameMobile from 'assets/ContactExample/image-nom-mobile.png';
import './ContactExampleModal.scss';

export const ContactExampleModal: React.FC = memo(() => {
  const { isOpen, open, close } = useModalState();
  return (
    <>
      <span className="modal-handle" onClick={open}>
        Voir un exemple
      </span>
      <Modal title="Protection de vos données" isOpen={isOpen} onClose={close} showCloseButton size="medium">
        <div className="contact-example-modal-content">
          <Text size="large" weight="bold">
            Votre adresse
          </Text>
          <Text>
            Votre adresse n&apos;apparaîtra pas sur le site, votre annonce sera positionnée au niveau de la ville
            uniquement.
          </Text>

          <div className="pictures">
            <img className="mobile-hidden" src={AdressDesktop} alt="" />
            <img className="mobile-only" src={AdressMobile} alt="" />
          </div>

          <Text size="large" weight="bold">
            Votre email
          </Text>
          <Text>L&apos;acheteur vous contacte via un formulaire, votre adresse email n&apos;est pas affichée.</Text>

          <div className="pictures">
            <img className="mobile-hidden" src={EmailDesktop} alt="" />
            <img className="mobile-only" src={EmailMobile} alt="" />
          </div>

          <Text size="large" weight="bold">
            Votre téléphone
          </Text>
          <Text>
            Votre numéro sera remplacé par un numéro de substitution (portable ou fixe) qui transférera les appels vers
            votre téléphone. Ce service est proposé par Sécuritel.
          </Text>

          <div className="pictures">
            <img className="mobile-hidden" src={PhoneDesktop} alt="" />
            <img className="mobile-only" src={PhoneMobile} alt="" />
          </div>

          <Text size="large" weight="bold">
            Votre nom
          </Text>
          <Text>Seules vos initiales sont affichées.</Text>

          <div className="pictures">
            <img className="mobile-hidden" src={NameDesktop} alt="" />
            <img className="mobile-only" src={NameMobile} alt="" />
          </div>
        </div>
      </Modal>
    </>
  );
});

ContactExampleModal.displayName = 'ExampleModal';
